import React from 'react';
import { Outlet } from "react-router-dom";
import CheckoutContextProvider from './CheckoutContext';

/**
 * 
 * @returns The purpose of this page is to wrap all checkout pages and forms
 * in the AppRoute so that proper navigation can be attained via route urls.
 * e.g. if result is not done via route clicking on sidebar does not allow to go back
 * to the checkout page.
 */
const CheckoutPage = () => {
    return (
        <>
            <CheckoutContextProvider>
                <Outlet/>
            </CheckoutContextProvider>
        </>
    )
}

export default CheckoutPage

